/**
 * @flow
 * @relayHash e99d86b4589fdc278f02a4915e9ecbce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PasswordChangeInput = {|
  newPassword1: string,
  newPassword2: string,
  oldPassword: string,
  clientMutationId?: ?string,
  revisionMessage?: ?string,
|};
export type ProfileChangePasswordMutationVariables = {|
  input: PasswordChangeInput
|};
export type ProfileChangePasswordMutationResponse = {|
  +mePasswordChange: ?{|
    +viewer: ?{|
      +id: string,
      +me: ?{|
        +id: string,
        +username: string,
        +isAuthenticated: ?boolean,
      |},
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +location: ?string,
      +message: string,
    |}>,
  |}
|};
export type ProfileChangePasswordMutation = {|
  variables: ProfileChangePasswordMutationVariables,
  response: ProfileChangePasswordMutationResponse,
|};
*/


/*
mutation ProfileChangePasswordMutation(
  $input: PasswordChangeInput!
) {
  mePasswordChange(input: $input) {
    viewer {
      id
      me {
        id
        username
        isAuthenticated
      }
    }
    errors {
      code
      location
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PasswordChangeInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mePasswordChange",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PasswordChangePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "username",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAuthenticated",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileChangePasswordMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileChangePasswordMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ProfileChangePasswordMutation",
    "id": null,
    "text": "mutation ProfileChangePasswordMutation(\n  $input: PasswordChangeInput!\n) {\n  mePasswordChange(input: $input) {\n    viewer {\n      id\n      me {\n        id\n        username\n        isAuthenticated\n      }\n    }\n    errors {\n      code\n      location\n      message\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cc7efb699301e3cde3e66d4eb5972238';
module.exports = node;
